import * as React from 'react';
import { Link } from 'react-router-dom';

export interface AnchorProps {
    id?: string;
    href: string;
    children?: any;
    className?: string;
    // callback?: (e: any) => void;
}

export function Anchor (props: AnchorProps) {
    return (
        <Link to={props.href} className={props.className}>{props.children}</Link>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Anchor.tsx